import { frontendURL } from '../../../../helper/URLHelper';
import SettingsShellWrapper from '../SettingsShellWrapper.vue';
import OfficeHoursIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/office-hours'),
      component: SettingsShellWrapper,
      children: [
        {
          path: '',
          name: 'office_hours_index',
          component: OfficeHoursIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
